<app-title-component [data]="{name : title() , path : 'assure', back : true}"></app-title-component>
<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
    <mat-card-header class="d-flex align-items-center justify-content-end p-3 border-bottom">
      <div class="mx-2 mt-4">
        <app-search-bar-component (searchBarValue)="applyFilter($event)"></app-search-bar-component>
      </div>
      <button class="btn-add px-4 py-4 fw-semibold" [disabled]="assure_id==''" matTooltip="Nouveau vehicule" (click)="openAddVehiculeModal()" mat-flat-button color="primary">
        <mat-icon>add</mat-icon>
        <span>Ajouter</span>
      </button>
  </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
      <!--loading-->
      @if (loading()) {
      <div class="loading-table-shade">
        <mat-spinner diameter="70" color="primary"></mat-spinner>
      </div>
      }

      <!---->
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
        <!--
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
          <td mat-cell *matCellDef="let row" data-label="ID" class="text-secondary small fw-medium"> {{row.id}} </td>
        </ng-container> -->

        <!-- -->
        <ng-container matColumnDef="immatriculation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Immatriculation </th>
          <td mat-cell *matCellDef="let row" class="fw-semibold text-dark" data-label="Immatriculation"> {{row.immatriculation | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="chassis">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> N* Chassis </th>

          <td mat-cell *matCellDef="let row" data-label="N* Chassis">
                <span>{{row.chassis | uppercase }}</span>
          </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Marque & Model </th>
          <td mat-cell *matCellDef="let row" class="fw-semibold text-dark"  data-label="Marque & Model"> {{row.marque+" "+row.model | uppercase }} </td>
        </ng-container>

        <!--
        <ng-container matColumnDef="nature">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Nature </th>
          <td mat-cell *matCellDef="let row"  data-label="Nature">
            @if (row.remorque) {
              <span class="state_blue">REMORQUE</span>
            }@else {
              VEHICULE TRACTEUR
            }
          </td>
        </ng-container>-->

          <!-- -->
        <ng-container matColumnDef="genre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Genre </th>
          <td mat-cell *matCellDef="let row"  data-label="Genre"> {{row.genre | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="energie">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Energie </th>
          <td mat-cell *matCellDef="let row"  data-label="Energie"> {{row.energie | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="puissance">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Puissance </th>
          <td mat-cell *matCellDef="let row"  data-label="Puissance"> {{row.puissance +' CV'}} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="place">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Place </th>
          <td mat-cell *matCellDef="let row"  data-label="Place"> {{row.place}} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Status </th>
          <td mat-cell *matCellDef="let row"  data-label="Status">

              @if(row.assurance_suspendu){<span class="state_orange">Suspendu</span>}
              @else if((!row.assurance) || row.assurance_annule){<span class="state_inactif">Non Assure</span> }
              @else {<span class="state_actif">Assure</span>}
          </td>
        </ng-container>

        <!-- -->

        <!-- Action -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef sticky="true" class="table-row-actions">Actions</th>
           <td mat-cell *matCellDef="let row" class="table-row-actions">
              @if ((row.assurance && !row.assurance_annule) || row.assurance_suspendu) {
                <button id="contrat"
                matTooltip="imprimer le contrat d'assurance"
                (click)="openPrintLink(row.assurance_id)"
                [disabled]="row.assurance_suspendu"
                matButton="" class="text-green" type="button">
                  <mat-icon>assignment</mat-icon>
                  Impression
                </button>
              }@else{
                @if (row.remorque) {
                  <button matTooltip="etablir une assurance pour la remorque"
                        (click)="selectVehiculeTracteur(row); $event.stopPropagation()"
                        matButton=""
                        class="text-orange"
                        [disabled]="vehiculeTracteurLoading()"
                        type="button">
                        @if (vehiculeTracteurLoading()) {<mat-spinner diameter="15"></mat-spinner>}
                        @else {<mat-icon>car_crash</mat-icon>}
                    </button>
                }@else {
                    <button matTooltip="etablir une assurance"
                    (click)="openAssuranceModal(row); $event.stopPropagation()"
                    matButton=""
                    [disabled]="row.assurance_suspendu"
                    class="text-orange"
                    type="button">
                      <mat-icon>car_crash</mat-icon>
                    </button>
                }
              <button
                matTooltip="modifier"
                (click)="openUpdateVehicule(row); $event.stopPropagation()"
                matButton="" color="primary" type="button">
                <mat-icon class="text-muted-icon">edit</mat-icon>
              </button>
              <button
                matTooltip="supprimer"
                (click)="confirm(row); $event.stopPropagation()"
                matButton=""
                color="warn"
                type="button">
                 <mat-icon>delete_outline</mat-icon>
              </button>
              }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
        </tr>
            </table>
      </div>  </mat-card-content>

  <div class="border-top bg-white">
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</mat-card>
